<template lang="pug">
    transition.modal
        .modal-mask(@click="$emit('close_modal')" )
            .modal-wrapper
                .modal-container(@click.stop='')
                    component(:is='currentView' @close_modal="$emit('close_modal')")
</template>

<script>
    import SextantHelp from './SextantHelp'
    import CommandsHelp from './CommandsHelp'

    export default {
        name: "base-modal"
        , components:{SextantHelp, CommandsHelp}
        , data(){
            return {currentView:'sextant-help'}
        }
        , methods:{
            show_commands(){
                this.currentView='commands-help';
            }
            ,show_sextants(){
                this.currentView='sextant-help';
            }
        }
    }
</script>

<style scoped>
    .example{
        display: block;
        margin:auto;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-footer{
        height:15px;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>


// WEBPACK FOOTER //
// src/components/modals/HelpModal.vue